import { render, staticRenderFns } from "./AppCollapseDelivery.vue?vue&type=template&id=9fa74580&scoped=true"
import script from "./AppCollapseDelivery.vue?vue&type=script&lang=js"
export * from "./AppCollapseDelivery.vue?vue&type=script&lang=js"
import style0 from "./AppCollapseDelivery.vue?vue&type=style&index=0&id=9fa74580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa74580",
  null
  
)

export default component.exports